// Plugin to add aria-controls to role=combobox
// If the site is updated to Vuetify v3 in the future, this plugin can be removed.

import Vue from "vue";

Vue.directive("aria-combobox", {
  inserted(el, binding, vnode) {
    const setAria = () => {
      Vue.nextTick(() => {
        const combo = el.querySelector('[role="combobox"]');

        if (combo) {
          const ariaOwns = combo.getAttribute("aria-owns");
          if (ariaOwns) {
            // Replace aria-owns with aria-controls (aria-owns is invalid on combobox role)
            combo.setAttribute("aria-controls", ariaOwns);
            combo.removeAttribute("aria-owns");
          }
        }
      });
    };

    // Use MutationObserver to watch for aria-owns changes
    const observer = new MutationObserver(() => {
      setAria();
    });

    // Start observing the element for attribute changes
    observer.observe(el, {
      attributes: true,
      subtree: true,
      attributeFilter: ["aria-owns", "aria-expanded", "aria-controls"]
    });

    // Initial attempt
    setAria();

    // Cleanup observer when directive is unbound
    (el as any)._ariaComboboxObserver = observer;
  },
  unbind(el) {
    const observer = (el as any)._ariaComboboxObserver;
    if (observer) {
      observer.disconnect();
    }
  }
});
